import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
const excel = {
  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  extension: 'csv',
  fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
//Default configuration items
let CONFIG: XLSX.Sheet2JSONOpts = {
  defval: '', // default value ""
  raw: false, // format or not
  blankrows: false  // ignore blank row or not
};

export abstract class ExcelModel {
  abstract export(json: any[], fileName: string): void;
  abstract read(file: Blob): Promise<any>;
}

@Injectable({
  providedIn: 'root'
})
export class ExcelService extends ExcelModel {
  constructor() {
    super();
  }

  export(json: any[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
    const fullName = `${fileName}_export_${new Date().getTime()}.${excel.extension}`;
    XLSX.writeFile(workbook, fullName);
  }
  /**
   * @description: read excel
   * @param file blob  type
   * @param config Set the format for reading Excel files, XLSX Sheet2JSONOpts type
   */
  read(file: Blob | File, config?: XLSX.Sheet2JSONOpts): Promise<any> {
    if (config) {
      CONFIG = Object.assign(CONFIG, config); //Custom configuration items
    }
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    // const JSON_OBJ = {};
    return new Promise((resolve) => {
      reader.onload = () => {
        const data = reader.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        //Only one sheet is read here
        workbook.SheetNames.forEach((sheetName) => {
          const XL_ROW_OBJECT = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], CONFIG);
          resolve(XL_ROW_OBJECT); // Will only execute once and pass the first sheet
        });
      };
    });
  }
}
